<div class="content-body content-body-scroll">
  <div class="chart-header">
    <div
      class="header-text d-flex align-items-center justify-space-between mb-1"
    >
      <div>
        <p class="text-primary font-size-20 fw-bold m-0">
          {{ dateRange.startDate | date: "dd-LLL-yyyy" }} to
          {{ dateRange.endDate | date: "dd-LLL-yyyy" }}
        </p>
      </div>
      <div>
        <div class="content-header m-0">
          <div class="year-picker">
            <div class="d-flex year-picker-content">
              <div>
                <mat-form-field appearance="fill" class="w-150">
                  <mat-select
                    panelClass="myPanelClass"
                    [disableOptionCentering]="true"
                    [(ngModel)]="selectedYearValue"
                    (selectionChange)="onSelectionChange($event.value)"
                  >
                    <mat-option
                      *ngFor="let year of selectYear | useEnumValues"
                      [value]="year.key"
                      title="{{ year.value }}"
                    >
                      {{ year.value }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <form *ngIf="showCalender" [formGroup]="rangeFormGroup">
                <mat-form-field appearance="fill">
                  <mat-date-range-input [rangePicker]="picker">
                    <input
                      matStartDate
                      matInput
                      #start
                      (dateChange)="onSelectionChange(7)"
                      formControlName="start"
                    />
                    <input
                      matEndDate
                      matInput
                      #end
                      formControlName="end"
                      (dateChange)="onSelectionChange(7)"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matPrefix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-wrapper">
    <div
      class="d-flex align-items-center justify-space-between gap-20 fund-details"
    >
      <mat-card>
        <mat-card-title>
          <div class="d-flex gap-20">
            <div class="icon">
              <mat-icon class="material-icons-outlined">publish</mat-icon>
            </div>
            <div>
              <p class="title">Total B.Forward</p>
              <p class="amount">£ {{ totalForward | numberPipe }}</p>
            </div>
          </div>
        </mat-card-title>
      </mat-card>

      <mat-card>
        <mat-card-title>
          <div class="d-flex gap-20">
            <div class="icon">
              <mat-icon class="material-icons-outlined"
                >currency_pound</mat-icon
              >
            </div>
            <div>
              <p class="title">Total Income</p>
              <p class="amount">£ {{ totalIncome | numberPipe }}</p>
            </div>
          </div>
        </mat-card-title>
      </mat-card>

      <mat-card>
        <mat-card-title>
          <div class="d-flex gap-20">
            <div class="icon">
              <mat-icon class="material-icons-outlined">shopping_bag </mat-icon>
            </div>
            <div>
              <p class="title">Total Expense</p>
              <p class="amount">£ {{ totalExpense | numberPipe }}</p>
            </div>
          </div>
        </mat-card-title>
      </mat-card>

      <mat-card>
        <mat-card-title>
          <div class="d-flex gap-20">
            <div class="icon">
              <mat-icon class="material-icons-outlined">import_export</mat-icon>
            </div>
            <div>
              <p class="title">Total Transfer</p>
              <p class="amount">£ {{ totalTransfer | numberPipe }}</p>
            </div>
          </div>
        </mat-card-title>
      </mat-card>
      <mat-card>
        <mat-card-title>
          <div class="d-flex gap-20">
            <div class="icon">
              <mat-icon class="material-icons-outlined"
                >account_balance_wallet</mat-icon
              >
            </div>
            <div>
              <p class="title">Total Balance</p>
              <p class="amount">£ {{ totalBalance | numberPipe }}</p>
            </div>
          </div>
        </mat-card-title>
      </mat-card>
    </div>
  </div>
  <div class="chart-wrapper d-flex gap-20 mt-2">
    <div class="card">
      <div
        class="d-flex align-items-center hr-bottom justify-space-between pb-10"
      >
        <h3 class="card-title">Fund Breakdown</h3>
        <ng-select
          #fundType1
          (focus)="fundType1.open()"
          (valueChange)="fundType1.close()"
          [disableOptionCentering]="true"
          [(ngModel)]="fundIdForBreakdown"
          (change)="onFundTypeChangeForBreakDown()"
          panelClass="mat-select-position"
        >
          <ng-option *ngFor="let ft of fundTypeList" [value]="ft.id">
            <div class="clamp" title="{{ ft.name }}">{{ ft.name }}</div>
          </ng-option>
        </ng-select>
      </div>
      <app-fund-breakdown
        [triggerHeaderFilter]="triggerHeaderFilter"
        [triggerHeaderFilterForFundBreakdown]="
          triggerHeaderFilterForFundBreakdown
        "
        [getModuleId]="moduleId"
        (triggerWidgetClick)="triggerWidgetClick($event)"
        (triggerModuleId)="setFundBreakDown($event)"
      ></app-fund-breakdown>
    </div>
  </div>

  <div class="chart-wrapper d-flex gap-20 mt-2">
    <div class="card">
      <div
        class="d-flex align-items-center hr-bottom justify-space-between pb-10"
      >
        <h3 class="card-title card-title-without-dropdown">
          Income & Expenses by fund type
        </h3>
      </div>
      <app-dashboard-cashflow-chart-v1
        [triggerHeaderFilter]="triggerHeaderFilter"
        [getModuleId]="moduleId"
      >
      </app-dashboard-cashflow-chart-v1>
    </div>
    <div class="card">
      <div
        class="d-flex align-items-center hr-bottom justify-space-between pb-10"
      >
        <h3 class="card-title">Income vs Expenses</h3>
        <ng-select
          #fundType
          (focus)="fundType.open()"
          (valueChange)="fundType.close()"
          [disableOptionCentering]="true"
          [(ngModel)]="fundIdForIncomeVsExpenses"
          (change)="onFundTypeChangeForIncomeVsExpenses()"
          panelClass="mat-select-position"
        >
          <ng-option *ngFor="let ft of fundTypeList" [value]="ft.id">
            <div class="clamp" title="{{ ft.name }}">{{ ft.name }}</div>
          </ng-option>
        </ng-select>
      </div>
      <app-dashboard-income-expenses-chart-v1
        [triggerHeaderFilterForIncomeVsExpenses]="
          triggerHeaderFilterForIncomeVsExpenses
        "
        [getModuleId]="moduleId"
      >
      </app-dashboard-income-expenses-chart-v1>
    </div>
  </div>
</div>
